<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        現場管理 - 新規登録
        <div class="headerBtn" @click="screenTransition(siteslistPath)" style="margin: 0px 0px 0px 20px;">
          一覧に戻る
        </div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <form v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              CCUS登録情報
            </div>
            <div class="row">
              <p class="inputTitle editable">現場ID</p>
              <validation-provider name="現場ID" rules="digits:14" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" :placeholder="'(例) 11111111111111'"
                   v-model="detail.ccusId">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              基本情報【必須】
            </div>
              <div class="row">
                <p class="inputTitle editable">事業者</p>
                <validation-provider name="事業者" rules="required" mode="lazy">
                  <div class="rowRight" slot-scope="ProviderProps">
                    <div class="company-multiselect">             
                      <multiselect
                        v-model="selectedCompany"
                        :options="optionCompanies"
                        :multiple="false"
                        :taggable="false"
                        label="companyName"
                        placeholder="事業者を選択"
                        selectLabel="選択"
                        deselectLabel="解除"
                        selectedLabel="選択済"
                        track-by="companyId"
                        @input="updateBranchsNameList($event ? $event.companyId : null)"
                      >
                        <span slot="noOptions"></span>
                      </multiselect>
                    </div>
                    <div class="errMsg" v-if="ProviderProps.errors[0]">
                      <span class="errSpan">
                        {{ ProviderProps.errors[0] }}
                      </span>
                    </div>
                  </div>
                </validation-provider>
              </div>
            <div class="row">
              <p class="inputTitle editable">支店</p>
              <validation-provider name="支店" rules="required" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <div class="selectdiv">
                    <select  v-model="detail.branchId" @change="updateWorkersList(detail.companyId,detail.branchId)">
                      <option value="" selected>支店を選択</option>
                      <option v-for="branch in optionBranches"
                        v-bind:value="branch.branchId">
                        {{ branch.branchName }}
                      </option>
                    </select>
                  </div>
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
            </validation-provider>
          </div>
            <div class="row">
              <p class="inputTitle editable">現場名</p>
              <validation-provider name="現場名" rules="required|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" :placeholder="'(例) 東京ドームシティホール'" v-model="detail.siteName">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">工期（開始）</p>
              <validation-provider name="工期（開始）" rules="required" vid="startDate" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" max="9999-12-31" type="date" v-model="detail.startDate">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">工期（終了）</p>
              <validation-provider name="工期（終了）" rules="required|periodValidity:startDate" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" max="9999-12-31" type="date" v-model="detail.endDate">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              住所【必須】
            </div>
            <div class="row">
              <p class="inputTitle editable">郵便番号</p>
              <validation-provider name="郵便番号" rules="required|digits:7|addressFlg" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input type="text" @change="getAddress()" class="text large"
                  name="postalCode" v-model="detail.postalCode" placeholder="例：1000001 ハイフン無し半角数字のみ入力"/>
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan" v-if="postalHasError">
                      {{ ProviderProps.errors[0] }}
                    </span>
                    <span class="prefectureErrSpan" v-if="!postalHasError">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">都道府県</p>
              <div class="rowRight">
                <validation-provider name="都道府県" rules="required||max:255" mode="lazy">
                  <div class="rowRight" slot-scope="ProviderProps">
                    <input type="text" class="text large" :placeholder="'例：東京都'" name="prefecture" 
                    v-model="detail.prefecture">
                      <div class="errMsg" v-if="ProviderProps.errors[0]">
                        <span class="errSpan">
                          {{ ProviderProps.errors[0] }}
                        </span>
                      </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">市区町村</p>
              <validation-provider name="市区町村" rules="required||max:255" mode="lazy">
                  <div class="rowRight" slot-scope="ProviderProps">
                    <input type="text" class="text large" :placeholder="'例：千代田区'" name="city" 
                    v-model="detail.city">
                      <div class="errMsg" v-if="ProviderProps.errors[0]">
                        <span class="errSpan">
                          {{ ProviderProps.errors[0] }}
                        </span>
                      </div>
                    </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">町・番地</p>
              <validation-provider name="町・番地" rules="required|max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" :placeholder="'例：丸の内1-1'" v-model="detail.town">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="row">
              <p class="inputTitle editable">建物名/部屋番号</p>
              <validation-provider name="建物名/部屋番号" rules="max:255" mode="lazy">
                <div class="rowRight" slot-scope="ProviderProps">
                  <input class="text large" :placeholder="'例：千代田ビル2F'" v-model="detail.otherAddress">
                  <div class="errMsg" v-if="ProviderProps.errors[0]">
                    <span class="errSpan">
                      {{ ProviderProps.errors[0] }}
                    </span>
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>

            <div class="group">
              <div class="groupTitle" style="display: flex;">
                現場管理者【任意】
              </div>
              <div class="row">
                <p class="inputTitle editable">現場管理者</p>
                <validation-provider name="現場管理者">
                  <div class="selectdiv">
                    <select  v-model="detail.supervisorId" @change="updateSiteTel(optionWorkers,detail.supervisorId)">
                      <option value="" selected>現場管理者を選択</option>
                      <option v-for="worker in optionWorkers"
                        v-bind:value="worker.workerId">
                        {{ worker.workerName }}
                      </option>
                    </select>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="group">
              <div class="groupTitle" style="display: flex;">
                連携設定
              </div>
              <div class="row">
                <p class="inputTitle editable">Face-DB Serverとの連携対象とする</p>
                <div class="switch switch__apartRow">
                  <label class="switch__label">
                    <input type="checkbox" class="switch__input" v-model="detail.syncFlg" true-value="1" false-value="0" :disabled="!detail.ccusId || detail.ccusId.trim() === ''" />
                    <span class="switch__content"></span>
                    <span class="switch__circle"></span>
                  </label>
                </div>
              </div>
            </div>
            <!-- ローディング -->
            <div v-if="postLodingFlg">
              <vue-loading
                type="cylon"
                color="#1b7e47"
                :size="{ width: '150px', height: '150px' }"
              >
              </vue-loading>
              <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
            </div>
            <!-- 登録エラー表示 -->
            <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
              <div　class="errMsg">
                <div class="errDiv">
                  データの登録中に問題が発生しました。
                </div>
              </div>
            </div>
            <!-- 入力チェックエラー表示 -->
            <div v-if="validationErrMsg.length > 0">
              <div　class="errMsg" v-for="error in validationErrMsg">
                <div class="errSpan">{{error}}</div>
              </div>
            </div>
            <!-- 登録ボタン -->
            <div class="buttonGroup">
            <button class="btn" type="button" @click="confirm"
              v-bind:class="{ disabled: isProcessing() || !ObserverProps.validate 
              ||!isPostDisabled(ObserverProps,postalHasError)
              || detail.companyId === ''
              || detail.branchId === ''
              || detail.siteName === ''
              || detail.startDate === ''
              || detail.endDate === ''
              || detail.postalCode === ''
              || detail.prefecture === ''
              || detail.city === ''
              || detail.town === '',
              active: isPostDisabled(ObserverProps,postalHasError)
              && detail.companyId !== ''
              && detail.branchId !== ''
              && detail.siteName !== ''
              && detail.startDate !== ''
              && detail.endDate !== ''
              && detail.postalCode !== ''
              && detail.prefecture !== ''
              && detail.city !== ''
              && detail.town !== ''
              && ObserverProps.validate }"
              :disabled="!isPostDisabled(ObserverProps,postalHasError)
              || detail.companyId === ''
              || detail.branchId === ''
              || detail.siteName === ''
              || detail.startDate === ''
              || detail.endDate === ''
              || detail.postalCode === ''
              || detail.prefecture === ''
              || detail.city === ''
              || detail.town === ''">登録
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import moment from 'moment';
import common from '../services/common';
import constants from "../constants/constants";

export default {
  title: '現場登録',
  name: 'SiteAdd',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      siteslistPath: '/sites', // 現場一覧パス
      // 入力項目モデル
      detail: {
        ccusId: '',
        // 選択した事業者用
        companyId: '',
        // 選択した支店用
        branchId: '',
        siteName: '',
        startDate: '',
        endDate: '',
        postalCode: '',
        prefecture: '',
        city: '',
        town: '',
        otherAddress: '',
        fullAddress: '',
        supervisorId: '',
        tel: '',
        approve: true,
        syncFlg: 0,
      },
      // 選択用事業者配列　事業者一覧取得APIが実装され次第そちらに変更
      optionCompanies: [],
      // 選択用支店配列
      optionBranches: [],
      // 選択用技能者配列
      optionWorkers: [],
      // ドロップダウンリスト
      selectedPrefectures: '', // 選択した都道府県用
      optionPrefectures: [],   // 選択用都道府県配列
      // ローディング
      getLodingFlg: false,     // データ取得時ローディング用フラグ
      getErrorFlg: false,      // データ取得時エラーフラグ
      postLodingFlg: false,    // データ登録時ローディングフラグ
      postErrorFlg: false,     // データ登録時エラーフラグ
      // 入力チェック
      validationErrFlg: false, // 入力チェックエラーフラグ
      validationErrMsg: [],    // 入力チェックエラーメッセージ用配列
      errorMessage: '',
      searchCondition: {},
      // 郵便番号エラー判定用フラグ
      postalHasError:true,
    };
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    // CCUS現場IDが未入力の場合はsyncFlgを0に固定
    'detail.ccusId'(newVal) {
      if (!newVal || newVal.trim() === '') {
        this.detail.syncFlg = 0;
      }
    },
  },
  // 初期処理
  async mounted() {
    try {
      // ローディング表示
      this.getLodingFlg = true;
      // this.detail.supervisorId = 'wa01w767-bf19-4a6d-81a8-710daf1635d5';
      // 事業者リスト取得API呼出
      this.optionCompanies = await this.callGetCompaniesList();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  methods: {
    // 事業者リスト取得API呼び出し
    async callGetCompaniesList() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getCompaniesNameList();
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // 支店名リスト取得API呼び出し
    async updateBranchsNameList(companyId) {
      try {
        this.detail.companyId = companyId;
        const restResourceService = new ApiClient();
        this.optionBranches = await restResourceService.getBranchesNameList(companyId);
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // 技能者リスト取得API呼出し
    async updateWorkersList(companyId, branchId) {
      try {
        this.searchCondition['companyId'] = companyId;
        this.searchCondition['branchId'] = branchId;
        const restResourceService = new ApiClient();
        // TODO: 取得人数
        const result =await restResourceService.getWorkersList(constants.LIMIT, constants.PAGE, this.searchCondition,{})
        this.optionWorkers = result.workers;
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    async updateSiteTel(optionWorkers, supervisorId) {
      try {
        const workers = await optionWorkers;
        await workers.forEach((worker) => {
          if (supervisorId === worker.workerId) {
            this.detail.tel = worker.tel;
          }
        });
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // 郵便番号を元に住所取得
    getAddress() {
      const restResourceService = new ApiClient();
      restResourceService.getAddress(this.detail.postalCode)
        .then((res) => {
          if(res === 404){
            this.postalHasError = false;
            this.detail.prefecture = "";
            this.detail.city = "";
            this.detail.town = "";
          } else{
            this.postalHasError = true;
            this.detail.prefecture = res.pref;
            this.detail.city = res.city;
            this.detail.town = res.town;
          }
        },
      );
    },
    // 登録ボタン押下時 登録処理
    async confirm() {
      // ボタン非活性化
      this.startProcessing();
      // ====================入力項目空白削除====================
      if (this.detail.otherAddress) {
        this.detail.fullAddress = this.detail.prefecture + this.detail.city + this.detail.town + this.detail.otherAddress;
      } else {
        this.detail.fullAddress = this.detail.prefecture + this.detail.city + this.detail.town;
      }
      this.detail.siteName = this.detail.siteName.trim();
      this.detail.town = this.detail.town.trim();
      if (this.detail.otherAddress) {
        this.detail.otherAddress = this.detail.otherAddress.trim();
      }
      if (this.detail.supervisorId) {
        this.detail.supervisorId = this.detail.supervisorId.trim();
      }
      // ====================入力チェック====================
      // 入力チェックフラグ・メッセージ初期化
      this.validationErrFlg = false;
      this.validationErrMsg = [];
      // 現場管理者存在チェック
      // if (this.detail.supervisorId) {
      //   const checksupervisorIdeFlg = await common.checksupervisorIde(this.detail.supervisorId);
      //   if (!checksupervisorIdeFlg) {
      //     this.validationErrFlg = true;
      //     this.validationErrMsg.push('一致する現場管理者が存在しません');
      //   }
      // }
      // 入力に不正がある場合、処理を中断
      if (this.validationErrFlg) {
        return;
      }

      if(this.detail.prefecture === undefined)this.detail.prefecture = '';
      if(this.detail.city === undefined)this.detail.city = '';
      if(this.detail.town === undefined)this.detail.town = '';
      if(this.detail.fullAddress === undefined)this.detail.fullAddress = '';
      // ====================API呼出処理====================
      try {
        // ローディング表示
        this.postLodingFlg = true;
        // エラーフラグ初期化
        this.postErrorFlg = false;
        const bodies = [];
        const body = {
           ccusId: this.detail.ccusId,
           siteName: this.detail.siteName,
           companyId: this.detail.companyId,
           parentCompanyId: '', // TODO 親会社IDを取得　選択欄追加
           rank: 1, // TODO 何次受けかを入力もしくは取得　方法不明
           branchId: this.detail.branchId,
           postalCode: this.detail.postalCode,
           prefecture: this.detail.prefecture,
           city: this.detail.city,
           town: this.detail.town,
           otherAddress: this.detail.otherAddress,
           fullAddress: this.detail.fullAddress,
           tel: this.detail.tel,
           supervisorId: this.detail.supervisorId,
           approve: this.detail.approve,
           startDate: common.unixTimeFormat(this.detail.startDate),
           endDate: common.unixTimeFormat(this.detail.endDate),
           syncFlg: (!this.detail.ccusId || this.detail.ccusId.trim() === '') ? 0 : parseInt(this.detail.syncFlg),
        };
        bodies.push(body);
        const restResourceService = new ApiClient();
        await restResourceService.postSite(bodies);
        this.screenTransition(this.siteslistPath);
      } catch (error) {
      this.errorMessage = error.message;
      this.postErrorFlg = true;
      this.endProcessing();
      } finally {
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    // 画面遷移
    screenTransition(path) {
      history.back();
    },
    // 更新ボタン判定用
    isPostDisabled(item,isError){
      return common.isPostalValidate(item,isError,4)
    },
    // チャタリング防止
    startProcessing() {
      this.processing = true;
    },
    endProcessing() {
      this.processing = false;
    },
    isProcessing() {
      return this.processing;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";

/*** iOS ***/
.switch__apartRow {
  margin-left: 10px;
}
.switch__label {
	width: 100px;
	position: relative;
	display: inline-block;
  margin-top: 13px;
}
.switch__content {
	display: block;
  cursor: pointer;
  position: relative;
  border-radius: 30px;
  height: 31px;
overflow: hidden;
}
.switch__content:before {
	content: "";
	display: block;
	position: absolute;
	width: calc(100% - 3px);
	height: calc(100% - 3px);
	top: 0;
	left: 0;
	border: 1.5px solid #E5E5EA;
	border-radius: 130px;
	background-color: #fff;
}
.switch__content:after {
	content: "";
	display: block;
	position: absolute;
	background-color: transparent;
	width: 0;
	height: 0;
	top: 50%;
	left: 50%;
	border-radius: 30px;
	-webkit-transition: all .5s;
	   -moz-transition: all .5s;
	    -ms-transition: all .5s;
	     -o-transition: all .5s;
	        transition: all .5s;
}
.switch__input {
	display: none;
}

.switch__circle {
	display: block;
	top: 2px;
	left: 2px;
	position: absolute;
	-webkit-box-shadow: 0 2px 6px #999;
	        box-shadow: 0 2px 6px #999;
	width: 27px;
	height: 27px;
	-webkit-border-radius: 20px;
	        border-radius: 20px;
	background-color: #fff;
	-webkit-transition: all .5s;
	   -moz-transition: all .5s;
	    -ms-transition: all .5s;
	     -o-transition: all .5s;
	        transition: all .5s;
}
.switch__input:checked ~ .switch__circle {
	left: 71px;
}

.switch__input:checked ~ .switch__content:after {
	background-color: #4BD964;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.selectdiv {
  position: relative;
  float: left;
  min-width: 494px;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 20px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}

// multiselectの外枠
.company-multiselect {
  min-width: 494px !important;
  max-width: 494px !important;
}

// 閉じているときの入力枠
.company-multiselect ::v-deep .multiselect__tags {
  border: 2px solid #000 !important;
  border-radius: 10px !important;
  min-height: 45px !important;
  font-size: 20px !important;
}

// 選択後に表示される1行
.company-multiselect ::v-deep .multiselect__single {
  color: #333 !important;
  font-size: 20px !important;
}

// 未選択時のプレースホルダ
.company-multiselect ::v-deep .multiselect__placeholder {
  color: #333 !important;
  font-size: 20px !important;
}

// 開いたドロップダウン一覧の外枠
.company-multiselect ::v-deep .multiselect__content-wrapper {
  border: 2px solid #000 !important;
  border-top: none !important;
}

// 一覧でフォーカスが当たっている行
.company-multiselect ::v-deep .multiselect__option--highlight {
  background: #666 !important;
  color: #ffffff !important;
}

// 上記行の右側ラベル
.company-multiselect ::v-deep .multiselect__option--highlight::after {
  background: #666 !important;
  color: #ffffff !important;
}

// すでに選択済みとしてマークされた行
.company-multiselect ::v-deep .multiselect__option--selected {
  color: #333 !important;
  font-size: 20px !important;
}

// 選択済み行でかつフォーカスも重なったとき
.company-multiselect ::v-deep .multiselect__option--selected.multiselect__option--highlight {
  background: #666 !important;
  color: #e8e8e8 !important;
}


</style>
